import { ReactNode } from "react";

import styles from "./Grid.module.scss";

export const Row = ({ children }: { children: ReactNode }) => {
  return <div className={styles.row}>{children}</div>;
};
